// test1866
(1866 && 0);
